module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1028-ab5fa2a54753328b3e92436c034b5f12.png";